import { render, staticRenderFns } from "./deleteWorkType.vue?vue&type=template&id=4cea918b&scoped=true"
import script from "./deleteWorkType.vue?vue&type=script&lang=js"
export * from "./deleteWorkType.vue?vue&type=script&lang=js"
import style0 from "./deleteWorkType.vue?vue&type=style&index=0&id=4cea918b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea918b",
  null
  
)

export default component.exports